import { parse } from 'wkt';

export default function parseWkt(wktFile) {
  try {
    return parse(wktFile);
  } catch (error) {
    console.warn(error);
    return undefined;
  }
}
